// @flow

import { Component } from 'react';

import {
    createLiveStreamingDialogEvent,
    sendAnalytics
} from '../../../analytics';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { getActiveSession } from '../../functions';

// CUSTOM
import { Constant } from '../../../webjam/constant';
import axios from 'axios';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../../customise/constant';
import { setRecording } from '../../../customise/redux/tool-webjam/actions';
import { setDefaultRecordingType } from '../../../customise/redux/tool-webjam-v2/actions';
import { getRecordingStreamingType } from '../../../customise/welcome-dashboard/Request.d';
// END

/**
 * The type of the React {@code Component} props of
 * {@link StopLiveStreamDialog}.
 */
type Props = {

    /**
     * The {@code JitsiConference} for the current conference.
     */
    _conference: Object,

    /**
     * The redux representation of the live stremaing to be stopped.
     */
    _session: Object,

    /**
     * Invoked to obtain translated strings.
     */
    t: Function
};

/**
 * A React Component for confirming the participant wishes to stop the currently
 * active live stream of the conference.
 *
 * @augments Component
 */
export default class AbstractStopLiveStreamDialog extends Component<Props> {
    /**
     * Initializes a new {@code StopLiveStreamDialog} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props: Props) {
        super(props);

        // Bind event handler so it is only bound once for every instance.
        this._onSubmit = this._onSubmit.bind(this);
    }

    _onSubmit: () => boolean;

    /**
     * Callback invoked when stopping of live streaming is confirmed.
     *
     * @private
     * @returns {boolean} True to close the modal.
     */

    // CUSTOM
    // _onSubmit() {
    async _onSubmit() {
        sendAnalytics(createLiveStreamingDialogEvent('stop', 'confirm.button'));

        // CUSTOM
        // const { _session } = this.props;
        const {
            _session,
            usersData,
            roomorIpAddress,
            isHybridSession,
            dispatch,
            authOrganization
        } = this.props;

        dispatch(setRecording({
            streamingStarted: 2
        }))

        let isJibriRecording = true; // check if recording is Started with jibri based on avstack
        let recordingTypeRes = await getRecordingStreamingType('?organization_id=' + authOrganization?._id)

        if (recordingTypeRes.data.status) {
            dispatch(setDefaultRecordingType(recordingTypeRes.data.data.recording_type));
            isJibriRecording = recordingTypeRes.data.data.recording_type == "JIBRI";
        }

        if (isJibriRecording == false) {
            if (usersData && !isHybridSession) {
                let url = Constant.App.ServerUrl + '/stop-audio-route?roomname=' + roomorIpAddress + "&processtype=recording";
                axios.get(url).then(response => {
                    console.log(" STOP STREAM response =>", response);
                }).catch(error => {
                    console.log("Invalid STOP streaming =>", error);
                });
            }
        }
        // END

        if (_session) {
            this.props._conference.stopRecording(_session.id);
        }

        return true;
    }
}

/**
 * Maps (parts of) the redux state to the React {@code Component} props of
 * {@code StopLiveStreamDialog}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {{
 *     _conference: Object,
 *     _session: Object
 * }}
 */
export function _mapStateToProps(state: Object) {
    return {
        _conference: state['features/base/conference'].conference,
        _session: getActiveSession(state, JitsiRecordingConstants.mode.STREAM),
        // CUSTOM
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        authOrganization: state[FEATURE_CUSTOM_REDUX_V2].authOrganization
        // END
    };
}
